var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasurmentCar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1222,
    height: 599,
    viewBox: "0 0 1222 599",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.999 5.83918C976.999 5.83918 831.945 6.48904 793.546 8.76356C760.938 10.694 760.461 22.124 757.957 36.3063C755.453 50.4886 742.914 143.132 742.914 143.132L741.385 150.3C741.385 150.3 738.231 224.556 736.874 236.865C735.517 249.174 733.606 260.471 733.606 260.471L734.619 303.82C734.619 303.82 731.828 342.659 737.945 354.127C736.091 359.498 742.226 371.444 742.226 371.444H736.358L741.29 402.313C741.29 402.313 743.048 408.391 752.72 410.398C762.391 412.405 884.928 417.087 976.234 417.087C1067.54 417.087 1202.88 410.283 1202.88 410.283C1202.88 410.283 1210.03 413.532 1213.7 396.158C1217.37 378.784 1217.7 371.731 1217.7 371.731L1212.94 371.559C1212.94 371.559 1217.2 359.747 1216.7 354.089C1221.96 342.85 1219.38 303.839 1219.38 303.839L1220.39 259.859C1220.39 259.859 1215.44 226.735 1214.5 201.123C1213.57 175.511 1211.1 141.546 1211.1 141.546C1211.1 141.546 1200.49 63.9636 1196.23 37.1473C1191.97 10.3309 1180.94 10.5794 1148.81 8.2475C1116.68 5.91564 1000.93 5.82007 977.037 5.82007L976.999 5.83918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.253 210.431C988.34 210.431 998.138 204.732 998.138 197.702C998.138 190.671 988.34 184.972 976.253 184.972C964.166 184.972 954.368 190.671 954.368 197.702C954.368 204.732 964.166 210.431 976.253 210.431Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.723 173.256H1186.29",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 248.257H928.487V282.069H1024V248.257Z",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.638 303.839C734.638 303.839 731.561 331.076 737.314 354.089C737.409 367.258 743.316 371.234 743.316 371.234L778.943 373.508C778.943 373.508 771.852 360.243 771.298 356.612C770.38 350.515 767.743 303.82 767.743 303.82H734.638V303.839Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.77 141.546H741.728L739.167 210.431C739.167 210.431 736.892 241.414 734.637 255.597C732.381 269.779 734.637 303.82 734.637 303.82H767.722V173.236L756.77 141.527V141.546Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.807 405.906V454.225C744.807 461.164 750.426 466.802 757.383 466.802H789.685C796.624 466.802 802.262 461.183 802.262 454.225V409.461L744.826 405.906H744.807Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.987 454.206H791.079",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.987 440.444H791.079",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.987 426.606H791.079",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.997 377.35C811.091 377.35 736.3 371.024 736.3 371.024L741.155 401.548C741.938 406.479 746.124 409.882 751.113 410.283C787.104 413.131 849.433 417.087 976.997 417.087",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.997 377.35C811.091 377.35 736.3 371.024 736.3 371.024L741.155 401.548C741.938 406.479 746.124 409.882 751.113 410.283C787.104 413.131 849.433 417.087 976.997 417.087",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.28 356.632L737.296 354.09",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.997 367.354C894.579 367.354 778.922 364.583 774.412 364.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.997 367.354C894.579 367.354 778.922 364.583 774.412 364.583",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.997 321.691H768.85",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.931 141.546C742.931 141.546 753.195 59.0325 758.241 34.9494C763.287 10.8662 772.519 9.54739 802.106 8.36235C831.694 7.17731 976.996 5.83936 976.996 5.83936",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.773 141.545L772.274 41.9633C773.516 33.9356 780.34 27.9531 788.463 27.781C819.255 27.1121 896.379 25.6594 976.254 25.6594",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.38 303.839C1219.38 303.839 1222.45 331.076 1216.7 354.089C1216.61 367.258 1210.7 371.234 1210.7 371.234L1175.07 373.508C1175.07 373.508 1182.16 360.243 1182.72 356.612C1183.63 350.515 1186.27 303.82 1186.27 303.82H1219.36L1219.38 303.839Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.25 141.546H1212.29L1214.85 210.431C1214.85 210.431 1217.13 241.414 1219.38 255.597C1221.64 269.779 1219.38 303.82 1219.38 303.82H1186.29V173.236L1197.25 141.527V141.546Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.19 405.906V454.225C1209.19 461.164 1203.57 466.802 1196.61 466.802H1164.31C1157.37 466.802 1151.73 461.183 1151.73 454.225V409.461L1209.17 405.906H1209.19Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.03 454.206H1162.93",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.03 440.444H1162.93",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.03 426.606H1162.93",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.998 377.35C1142.9 377.35 1217.7 371.024 1217.7 371.024L1212.84 401.548C1212.06 406.479 1207.87 409.882 1202.88 410.283C1166.89 413.131 1104.56 417.087 976.998 417.087",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.998 377.35C1142.9 377.35 1217.7 371.024 1217.7 371.024L1212.84 401.548C1212.06 406.479 1207.87 409.882 1202.88 410.283C1166.89 413.131 1104.56 417.087 976.998 417.087",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.72 356.632L1216.7 354.09",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.998 367.354C1059.42 367.354 1175.07 364.583 1179.58 364.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.998 367.354C1059.42 367.354 1175.07 364.583 1179.58 364.583",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.998 321.691H1185.16",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.08 141.546C1211.08 141.546 1200.82 59.0325 1195.75 34.9303C1190.69 10.828 1181.47 9.52828 1151.89 8.36235C1122.3 7.19642 976.998 5.83936 976.998 5.83936",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.24 141.545L1181.74 41.9633C1180.5 33.9356 1173.68 27.9531 1165.55 27.781C1134.76 27.1121 1057.64 25.6594 977.763 25.6594",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4417 10.9292C98.4417 10.9292 77.5314 7.89009 72.084 26.7361C66.6367 45.5821 56.1815 82.7963 48.3258 112.575C40.4701 142.354 42.8211 152.599 42.8211 152.599C42.8211 152.599 38.8646 165.73 41.1009 178.708C36.743 180.754 34.4685 187.673 34.2582 191.534C34.048 195.395 27.6831 224.409 35.233 244.841C29.0593 252.391 21.7197 274.104 28.8682 276.226C24.2427 281.597 23.8413 328.559 23.8413 353.196C23.8413 377.834 24.2045 409.276 26.9759 415.985C29.7474 422.694 33.1305 423.783 33.1305 423.783L30.856 435.901L31.5632 457.327C31.5632 457.327 34.3156 466.75 46.5865 466.75H77.0918C94.619 466.75 88.9996 433.168 88.9996 433.168L89.8024 430.014C89.8024 430.014 176.655 435.882 261.672 435.882C346.689 435.882 438.492 429.976 438.492 429.976L438.626 455.951C438.626 455.951 437.192 465.24 452.98 466.75C468.768 468.26 485.129 466.617 485.129 466.617C485.129 466.617 495.087 466.636 495.928 449.433C496.769 432.231 495.297 423.267 495.297 423.267C495.297 423.267 502.045 423.018 502.79 393.507C503.535 363.996 503.287 306.406 502.064 291.536C500.84 276.666 499.655 275.863 499.655 275.863C499.655 275.863 503.363 271.792 500.152 262.464C496.941 253.137 491.704 245.377 491.704 245.377C491.704 245.377 496.769 240.77 495.756 212.883C494.743 184.997 488.799 179.932 488.799 179.932C488.799 179.932 486.945 179.167 486.945 177.542C486.945 175.918 486.945 163.59 486.945 163.59C486.945 163.59 486.811 157.053 484.479 150.172C485.282 118.156 462.078 49.3284 462.078 49.3284C462.078 49.3284 455.503 18.3643 445.182 13.433C439.333 11.2732 428.17 10.91 428.17 10.91C428.17 10.91 383.215 2.15601 260.506 2.15601C137.797 2.15601 98.4417 10.9292 98.4417 10.9292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.811 270.339L106.662 267.931L108.688 283.834C109.032 286.586 111.211 288.746 113.964 289.09L124.782 290.428C130.822 291.173 136.9 291.556 142.978 291.556H385.797C391.875 291.556 397.953 291.173 403.993 290.428L414.812 289.09C417.564 288.746 419.743 286.586 420.087 283.834L422.113 267.931L414.965 270.339",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.811 270.339L106.662 267.931L108.688 283.834C109.032 286.586 111.211 288.746 113.964 289.09L124.782 290.428C130.822 291.173 136.9 291.556 142.978 291.556H385.797C391.875 291.556 397.953 291.173 403.993 290.428L414.812 289.09C417.564 288.746 419.743 286.586 420.087 283.834L422.113 267.931L414.965 270.339",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.728 154.625L487.136 153.745C488.264 153.325 488.99 152.274 488.99 151.069V128.535C488.99 118.213 496.406 108.561 506.899 108.561C517.393 108.561 515.233 108.561 515.233 108.561C525.287 108.561 526.567 119.054 526.567 122.112V148.891C526.567 155.026 521.731 159.556 517.832 160.11C512.595 160.856 496.807 162.461 494.418 162.461C490.156 162.461 487.04 164.105 487.04 164.105",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.728 154.625L487.136 153.745C488.264 153.325 488.99 152.274 488.99 151.069V128.535C488.99 118.213 496.406 108.561 506.899 108.561C517.393 108.561 515.233 108.561 515.233 108.561C525.287 108.561 526.567 119.054 526.567 122.112V148.891C526.567 155.026 521.731 159.556 517.832 160.11C512.595 160.856 496.807 162.461 494.418 162.461C490.156 162.461 487.04 164.105 487.04 164.105",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.728 154.625C484.728 154.625 484.48 142.488 479.988 116.57C475.496 90.652 459.135 41.0713 455.484 26.717C451.834 12.3627 437.46 9.22807 427.598 10.9101C432.395 14.5799 436.81 30.2148 436.81 30.2148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.728 154.625C484.728 154.625 484.48 142.488 479.988 116.57C475.496 90.652 459.135 41.0713 455.484 26.717C451.834 12.3627 437.46 9.22807 427.598 10.9101C432.395 14.5799 436.81 30.2148 436.81 30.2148",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.964 181.06V164.087C486.964 157.244 485.473 149.943 478.974 147.802C474.578 146.349 467.888 149.656 463.454 150.86",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.964 181.06V164.087C486.964 157.244 485.473 149.943 478.974 147.802C474.578 146.349 467.888 149.656 463.454 150.86",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.854 339.626C391.854 339.626 347.128 342.513 263.736 342.513C185.79 342.513 135.617 339.626 135.617 339.626",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.854 339.626C391.854 339.626 347.128 342.513 263.736 342.513C185.79 342.513 135.617 339.626 135.617 339.626",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5435 417.055V454.192C31.5435 461.131 37.1629 466.769 44.1202 466.769H76.4222C83.3604 466.769 88.999 461.15 88.999 454.192V420.61L31.5626 417.055H31.5435Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7075 454.154H77.8192",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7075 440.852H77.8192",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.928 417.055V454.192C495.928 461.131 490.309 466.769 483.351 466.769H451.049C444.111 466.769 438.473 461.15 438.473 454.192V420.61L495.909 417.055H495.928Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.747 454.154H449.655",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.747 440.852H449.655",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.605 276.226C493.578 273.55 446.902 273.339 446.902 273.339L415.174 400.98L404.145 414.398C404.145 414.398 336.923 417.781 263.717 417.781C190.512 417.781 123.29 414.398 123.29 414.398L112.261 400.98L80.5327 273.339C80.5327 273.339 33.8573 273.55 28.8304 276.226C21.3379 280.22 23.8991 399.699 25.6575 408.874C27.8365 420.208 25.6575 425.579 53.8119 427.663C151.119 434.868 263.698 435.901 263.698 435.901C263.698 435.901 376.277 434.868 473.585 427.663C501.739 425.579 499.56 420.227 501.739 408.874C503.498 399.699 506.059 280.22 498.566 276.226H498.605Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8397 154.625L40.4314 153.745C39.3037 153.325 38.5773 152.274 38.5773 151.069V128.535C38.5773 118.213 31.1613 108.561 20.6679 108.561C10.1745 108.561 12.3344 108.561 12.3344 108.561C2.28061 108.561 1 119.054 1 122.112V148.891C1 155.026 5.83574 159.556 9.73492 160.11C14.972 160.856 30.7599 162.461 33.1491 162.461C37.4114 162.461 40.5269 164.105 40.5269 164.105",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8397 154.625L40.4314 153.745C39.3037 153.325 38.5773 152.274 38.5773 151.069V128.535C38.5773 118.213 31.1613 108.561 20.6679 108.561C10.1745 108.561 12.3344 108.561 12.3344 108.561C2.28061 108.561 1 119.054 1 122.112V148.891C1 155.026 5.83574 159.556 9.73492 160.11C14.972 160.856 30.7599 162.461 33.1491 162.461C37.4114 162.461 40.5269 164.105 40.5269 164.105",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8408 154.625C42.8408 154.625 43.0893 142.488 47.581 116.57C52.0727 90.652 68.4339 41.0713 72.0846 26.717C75.7353 12.3627 90.1088 9.22807 99.9714 10.9101C95.1739 14.5799 90.7586 30.2148 90.7586 30.2148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8408 154.625C42.8408 154.625 43.0893 142.488 47.581 116.57C52.0727 90.652 68.4339 41.0713 72.0846 26.717C75.7353 12.3627 90.1088 9.22807 99.9714 10.9101C95.1739 14.5799 90.7586 30.2148 90.7586 30.2148",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5063 181.06V164.087C40.5063 157.244 41.9972 149.943 48.4958 147.802C52.892 146.349 59.5817 149.656 64.0161 150.86",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5063 181.06V164.087C40.5063 157.244 41.9972 149.943 48.4958 147.802C52.892 146.349 59.5817 149.656 64.0161 150.86",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.737 247.862C274.589 247.862 283.386 243.232 283.386 237.521C283.386 231.81 274.589 227.181 263.737 227.181C252.885 227.181 244.088 231.81 244.088 237.521C244.088 243.232 252.885 247.862 263.737 247.862Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7673 245.396C35.7673 245.396 27.7778 251.971 25.7136 272.021C25.5033 274.028 26.8795 275.863 28.8673 276.226C40.4119 278.291 56.3718 280.813 66.7314 284.923C74.5488 288.019 80.4358 294.575 82.6912 302.679L113.693 414.418H123.327L96.9691 264.835L35.7864 245.396H35.7673Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5097 181.059C39.9363 179.549 37.8147 179.53 37.2221 181.021C30.972 196.484 31.0293 228.346 32.6349 238.935C33.7626 246.408 39.9172 249.199 49.8371 251.301C62.605 254.015 101.539 266.019 113.829 270.319C115.015 270.74 116.257 269.861 116.257 268.599C116.295 248.167 114.326 228.25 107.121 222.325C97.9652 214.775 64.5928 202.141 49.1299 194.553C43.6061 191.839 42.0005 184.901 40.5288 181.059H40.5097Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.703 245.396C491.703 245.396 499.693 251.971 501.757 272.021C501.967 274.028 500.591 275.863 498.603 276.226C487.059 278.291 471.099 280.813 460.739 284.923C452.922 288.019 447.035 294.575 444.78 302.679L413.777 414.418H404.144L430.502 264.835L491.684 245.396H491.703Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.963 181.059C487.536 179.549 489.658 179.53 490.251 181.021C496.501 196.484 496.443 228.346 494.838 238.935C493.71 246.408 487.556 249.199 477.636 251.301C464.868 254.015 425.933 266.019 413.643 270.319C412.458 270.74 411.216 269.861 411.216 268.599C411.178 248.167 413.146 228.25 420.352 222.325C429.508 214.775 462.88 202.141 478.343 194.553C483.867 191.839 485.472 184.901 486.944 181.059H486.963Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7666 167.145C54.7666 167.145 119.848 209.959 143.779 213.667C167.709 217.375 263.736 215.349 263.736 215.349",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7666 167.145C54.7666 167.145 119.848 209.959 143.779 213.667C167.709 217.375 263.736 215.349 263.736 215.349",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.703 167.145C472.703 167.145 407.622 209.959 383.691 213.667C359.761 217.375 263.734 215.349 263.734 215.349",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.703 167.145C472.703 167.145 407.622 209.959 383.691 213.667C359.761 217.375 263.734 215.349 263.734 215.349",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.789 148.05L445.274 39.5807C444.433 34.9552 440.993 31.4192 436.692 30.8075C420.331 28.4566 373.025 23.5635 263.733 23.5635C154.442 23.5635 107.136 28.4757 90.7745 30.8075C86.4739 31.4192 83.0143 34.9552 82.1925 39.5807L62.6775 148.05C61.932 152.16 64.5315 156.116 68.3733 156.671L82.2116 158.716C106.486 162.309 130.97 164.106 155.474 164.106H372.031C396.535 164.106 421.019 162.309 445.294 158.716L459.132 156.671C462.955 156.097 465.554 152.16 464.828 148.05H464.789Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.69 262.484H250.259C244.659 262.484 239.326 260.114 235.58 255.947L226.94 246.352C225.832 245.129 224.264 244.422 222.601 244.422H143.624C138.884 244.422 134.201 243.16 130.13 240.733",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.69 262.484H250.259C244.659 262.484 239.326 260.114 235.58 255.947L226.94 246.352C225.832 245.129 224.264 244.422 222.601 244.422H143.624C138.884 244.422 134.201 243.16 130.13 240.733",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.692 262.484H279.123C284.723 262.484 290.056 260.114 293.802 255.947L302.442 246.352C303.55 245.129 305.118 244.421 306.781 244.421H385.949C390.575 244.421 395.104 243.198 399.137 240.924",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.692 262.484H279.123C284.723 262.484 290.056 260.114 293.802 255.947L302.442 246.352C303.55 245.129 305.118 244.421 306.781 244.421H385.949C390.575 244.421 395.104 243.198 399.137 240.924",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.597 10.9293C411.236 8.57835 373.028 2.17529 263.736 2.17529C154.444 2.17529 116.332 8.57835 99.9707 10.9293",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.597 10.9293C411.236 8.57835 373.028 2.17529 263.736 2.17529C154.444 2.17529 116.332 8.57835 99.9707 10.9293",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.476 510.099L197.603 510.099",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1973 472.848L96.1973 510.099",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.26 510.099L429.388 510.099",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M435.597 472.848L435.597 510.099",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.03 104.475L1184.76 104.475",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M766.718 104.475L907.444 104.475",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3208 597.019L199.673 597.019",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1123 472.848L34.1123 597.018",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M336.26 597.019L489.403 597.019",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M497.682 472.848L497.682 597.018",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M621.853 11.3667L621.852 176.318",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M729.467 1L514.238 0.999992",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M729.467 460L514.238 460",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M621.853 297.567L621.852 460.429",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurmentCar1);
export default __webpack_public_path__ + "static/media/measurment-car-1.29062ef7a8bd7b5f06fb2bb6b29011ff.svg";
export { ForwardRef as ReactComponent };